import api from "src/services/api";

export interface CargoOrganizacionItem {
  cargo: string;
  es_adm: boolean;
  sugerido_adm?: boolean;
}

export const obtenerCargosOrganizacion = async (): Promise<CargoOrganizacionItem[]> => {
  const { data } = await api.get<{ datos?: CargoOrganizacionItem[] }>("inicio/cargos-organizacion");
  return data?.datos || [];
};

export const actualizarCargosOrganizacion = async (
  items: CargoOrganizacionItem[]
): Promise<CargoOrganizacionItem[]> => {
  const { data } = await api.put<{ datos?: CargoOrganizacionItem[] }>("inicio/cargos-organizacion", {
    items: items.map((item) => ({
      cargo: item.cargo,
      es_adm: Boolean(item.es_adm),
    })),
  });
  return data?.datos || [];
};
